"use strict";

module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) > -1;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/is-date-filter.js